/**
 * Usuários mockados para AUTH_MODE=dev (sandbox local).
 * Em prod, MSAL/Entra é a fonte de verdade — esta lista é ignorada.
 *
 * O backend, em AUTH_MODE=dev, faz upsert lazy no Postgres usando o email
 * recebido no header `X-Dev-User`. Os emails da lista SEED_ADMIN_EMAILS no
 * backend são automaticamente promovidos a is_admin=true ao primeiro login.
 */

export interface DevUser {
  email: string;
  name: string;
  description: string;
  /** Esperado virar admin pelo seed do backend */
  expectedAdmin: boolean;
}

export const DEV_USERS: DevUser[] = [
  {
    email: "guilherme.armond@juscapital.com.br",
    name: "Guilherme Armond",
    description: "Admin (seed)",
    expectedAdmin: true,
  },
  {
    email: "aldo.toledo@juscapital.com.br",
    name: "Aldo Toledo",
    description: "Aprovado (regular)",
    expectedAdmin: false,
  },
  {
    email: "novo@juscapital.com.br",
    name: "Usuário Novo",
    description: "Pendente de aprovação",
    expectedAdmin: false,
  },
];

const STORAGE_KEY = "irjuscap-dev-user-email";

export function getActiveDevEmail(): string {
  return (
    localStorage.getItem(STORAGE_KEY) ??
    DEV_USERS[0].email
  );
}

export function setActiveDevEmail(email: string) {
  localStorage.setItem(STORAGE_KEY, email);
}

export function clearActiveDevEmail() {
  localStorage.removeItem(STORAGE_KEY);
}
